import { Card, Heading, Text } from "@/design-system";
import { PageSection } from "@/pages/landingPage/components/pageSection";

type ShortAnswerProps = {
  id: string;
  title: string;
  answer: string;
  bullets: string[];
};

/**
 * Resposta curta e autossuficiente logo depois da prova: é o trecho que o AI
 * Overview e os LLMs extraem sem o resto da página junto.
 */
export const ShortAnswer = ({
  id,
  title,
  answer,
  bullets,
}: ShortAnswerProps) => (
  <PageSection labelledBy={`${id}-title`}>
    <Card className="flex flex-col gap-4 md:p-10">
      <Heading level={2} id={`${id}-title`}>
        {title}
      </Heading>
      <Text size="lead">{answer}</Text>
      <ul className="flex list-disc flex-col gap-2 pl-5">
        {bullets.map(bullet => (
          <Text as="li" key={bullet} tone="muted">
            {bullet}
          </Text>
        ))}
      </ul>
    </Card>
  </PageSection>
);
